// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*==== Header classes ====*/
.header-content {
    display: flex;
    justify-content: space-between;
    padding: 13px 24px;
    align-items: center;
    width: 100%;
    min-height: 72px;
    background: #FFFFFF;
    position: relative;
}
.header-content.nologin_navbar{
    align-items: start;
}

.header-content.nologin_navbar .header-right a {
    display: inline-block !important;
}
.header-content.nologin_navbar .header-right{
    align-items: center;
}
.header{
    box-shadow: 0px 0px 7px 0px #3333;
}
.header-ul li {
    list-style: none;
    list-style-type: none;
}

.header-ul .nav-item{
  padding-left: 20px;
}

.header-ul {
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
}
.header .dropdown-toggle::after {
    opacity: 0;
    display: none;
}
.user-profile {
    display: flex;
    align-items: center;
}
.user-photo {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: 100%;
    margin-right: 10px;
}
.cart-btn {
    font-size: 20px;
    color: #000;
}
.user-profile span {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000;
}
.account-balance {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: var(--darkblue);
}
.account-balance span.fw-bold {
    font-weight: 700;
    font-size: 20px;
    line-height: 32px;
}

.header-logo img {
    min-width: 100px;
}

.user-pname {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000;
}

.logout_button,
.logout_button:hover{
    border: 0px;
    width: 100%;
    text-align: left;
    background-color: transparent !important;
    color: #515457 !important;
    padding: 0px;
    padding-left: 16px;
    font-weight: 500;
}

.inlogin_navbar .header-ul .nav-item {
white-space: nowrap;
}

.balanace_seriel .dropdown-toggle::after{
display: none;
}
.balanace_seriel .dropdown-toggle{
    padding-bottom: 0px;
    padding-top: 0px;
}

/*==== Min Width media query ====*/


@media only screen and (max-width: 1555px){
    @media only screen and (min-width: 1400px){
        .header-content.inlogin_navbar{
            flex-wrap: nowrap ;
        }
        .header-content.inlogin_navbar .header-right,
        .header-content.inlogin_navbar .header-left
        {
            width:auto;
        }

       
         
    }
    .header-content.inlogin_navbar .header-left ul.login_show_mobile{
        gap: 9px;
    }
        .header-content.inlogin_navbar .header-left{
            align-items: center;
        }
        .header-content.inlogin_navbar .header-center .search-bar{
                    max-width: 100%;
        }
        .header-content.inlogin_navbar .header-center .search-bar .responsive_width {
            max-width: 100% !important;
        }

        @media only screen and (max-width: 1399.98px){
            .header-content.inlogin_navbar{
                flex-wrap: wrap;
            }
        }
 .header-ul li{
    white-space: nowrap;
 }
    .header-content.nologin_navbar{
        flex-wrap: nowrap;
    }
    .header-left{
        width: 100%;
        justify-content: space-between;
    }
    .header-right{
        width:100%;
        display: flex;
        justify-content: end;
    }
    .header-right.nologin_navbar{
        margin-top: 0px;
        width: auto;
    }
    .product_listing {
        margin-top: 323px;
    }
}

@media only screen and (min-width: 768px){
  
}

@media only screen and (min-width: 992px){
    .responsive_width{
        /* max-width: 338px !important; */
        max-width: 100% !important;
    }
}

@media only screen and (min-width: 425px) and (max-width:575.98px){
    /* .header-left, */
    .header-content{
        /* display: block !important; */
    }
    .header-content.nologin_navbar.reponsive_nologin{
        display: flex !important;
    }


}

/*==== Min & Max Width media query ====*/
@media only screen and (min-width: 767px) and (max-width: 1200px){
}

/*==== Max Width media query ====*/

@media only screen and (max-width: 1200px){
  
}

@media only screen and (max-width: 991px){
.account-balance span {
    font-size: 16px;
}
.header-ul .nav-item {
    padding-left: 10px;
}
.header-ul .nav-item .btn-main {
    /* border-radius: 10px; */
    padding: 6px 12px;
}
.header-content {
    padding: 10px 10px;
}  
.user-photo {
    margin-right: 0px;
}
}

@media only screen and (max-width: 767px){
    .account-balance span {
        font-size: 14px !important;
    }
}

@media only screen and (max-width: 1100px){
    .user-pname{
        display:none;
    }
}

@media only screen and (max-width: 575px){
    
    .header-content.nologin_navbar{
        flex-wrap: wrap;
    }
    .header-right.nologin_navbar{
        margin-top: 15px;
    }
    .header-content.nologin_navbar   .header-left {
        width: 100% !important;
    }
    div.header-content.nologin_navbar.reponsive_nologin{
        flex-wrap: nowrap !important;
        align-items: center !important;
    }
}

@media only screen and (max-width: 425px){
.header-logo img {
    min-width: 150px;
}
.header-logo {
    max-width: 32px;
    overflow: hidden;
    display: block;
}

.mobile_View_logo img{
    max-width: 80px !important;
    max-height: 36px !important;
}

}

.balanace_seriel{
    display: none;
}


.dropdown_header,.dropdown_header:hover,.dropdown_header.btn:first-child:active {
background-color: #ffffff00 !important;
border: 0px;
color: #000 !important; 
}
.dropdown_header svg{
    color: blue;
}

@media screen and (max-Width:776px) {
    .balanace_seriel{
        display: block;
    }
    .bonus_cash{
     display: none;
    }
}

/* @media screen and (min-Width:657px) and (max-width:658px) {
    .bonus_cash{
        display: block;
    }
} */

@media only screen and (min-width: 993px) {
    .header_center {
        position: absolute;
        left: 205px;
        max-width: 70%;
    }
}
@media only screen and (max-width: 992px) {
    .header_center {
        position: absolute;
        left: 205px;
        max-width: 30%;
    }
}
@media only screen and (min-width: 776px) and (max-width: 949px) {
    .header_center {
        position: absolute;
        left: 205px;
        max-width: 30%;
    }
}
@media only screen and (min-width: 676px) and (max-width: 775px) {
    .header_center {
        position: absolute;
        left: 205px;
        max-width: 45%;
    }
}
@media only screen and (min-width: 605px) and (max-width: 675px) {
    .header_center {
        position: absolute;
        left: 185px;
        max-width: 40%;
    }
}
@media only screen and (min-width: 577px) and (max-width: 604px) {
    .header_center {
        position: absolute;
        left: 205px;
        max-width: 35%;
    }
}
/* @media only screen and (min-width: 670px) and (max-width: 699px) {
    .header_center {
        position: absolute;
        left: 205px;
        max-width: 25%;
    }
} */
@media only screen and (min-width: 516px) and (max-width: 576px) {
    .header_center {
        position: absolute;
        left: 195px;
        max-width: 37%;
    }
}
@media only screen and (min-width: 480px) and (max-width: 515px) {
    .header_center {
        position: absolute;
        left: 195px;
        max-width: 35%;
    }
}
@media only screen and (min-width: 425px) and (max-width: 479px) {
    .header_center {
        position: absolute;
        left: 190px;
        max-width: 27%;
    }
}
@media only screen and (min-width: 340px) and (max-width: 424px) {
    .header_center {
        position: absolute;
        left: 65px;
        max-width: 40%;
    }
}
@media only screen and (min-width: 300px) and (max-width: 339px) {
    .header_center {
        position: absolute;
        left: 50px;
        max-width: 40%;
    }
}


@media only screen and (max-width: 991px) {
    .search-bar {
        margin-right: 0!important;
    }
}

`, "",{"version":3,"sources":["webpack://./src/styles/header.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,iCAAiC;AACrC;AACA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,wCAAwC;IACxC,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,aAAa;AACb;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,kCAAkC;;;AAGlC;IACI;QACI;YACI,kBAAkB;QACtB;QACA;;;YAGI,UAAU;QACd;;;;IAIJ;IACA;QACI,QAAQ;IACZ;QACI;YACI,mBAAmB;QACvB;QACA;oBACY,eAAe;QAC3B;QACA;YACI,0BAA0B;QAC9B;;QAEA;YACI;gBACI,eAAe;YACnB;QACJ;CACP;IACG,mBAAmB;CACtB;IACG;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,8BAA8B;IAClC;IACA;QACI,UAAU;QACV,aAAa;QACb,oBAAoB;IACxB;IACA;QACI,eAAe;QACf,WAAW;IACf;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;;AAEA;;AAEA;IACI;QACI,iCAAiC;QACjC,0BAA0B;IAC9B;AACJ;;AAEA;IACI,kBAAkB;IAClB;QACI,+BAA+B;IACnC;IACA;QACI,wBAAwB;IAC5B;;;AAGJ;;AAEA,wCAAwC;AACxC;AACA;;AAEA,kCAAkC;;AAElC;;AAEA;;AAEA;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;;IAEI;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,4BAA4B;QAC5B,8BAA8B;IAClC;AACJ;;AAEA;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;;AAEA;IACI,aAAa;AACjB;;;AAGA;AACA,sCAAsC;AACtC,WAAW;AACX,sBAAsB;AACtB;AACA;IACI,WAAW;AACf;;AAEA;IACI;QACI,cAAc;IAClB;IACA;KACC,aAAa;IACd;AACJ;;AAEA;;;;GAIG;;AAEH;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,cAAc;IAClB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,cAAc;IAClB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,cAAc;IAClB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,cAAc;IAClB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,cAAc;IAClB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,cAAc;IAClB;AACJ;AACA;;;;;;GAMG;AACH;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,cAAc;IAClB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,cAAc;IAClB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,cAAc;IAClB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,UAAU;QACV,cAAc;IAClB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,UAAU;QACV,cAAc;IAClB;AACJ;;;AAGA;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["/*==== Header classes ====*/\n.header-content {\n    display: flex;\n    justify-content: space-between;\n    padding: 13px 24px;\n    align-items: center;\n    width: 100%;\n    min-height: 72px;\n    background: #FFFFFF;\n    position: relative;\n}\n.header-content.nologin_navbar{\n    align-items: start;\n}\n\n.header-content.nologin_navbar .header-right a {\n    display: inline-block !important;\n}\n.header-content.nologin_navbar .header-right{\n    align-items: center;\n}\n.header{\n    box-shadow: 0px 0px 7px 0px #3333;\n}\n.header-ul li {\n    list-style: none;\n    list-style-type: none;\n}\n\n.header-ul .nav-item{\n  padding-left: 20px;\n}\n\n.header-ul {\n    padding: 0;\n    margin: 0;\n    display: flex;\n    align-items: center;\n}\n.header .dropdown-toggle::after {\n    opacity: 0;\n    display: none;\n}\n.user-profile {\n    display: flex;\n    align-items: center;\n}\n.user-photo {\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    border-radius: 100%;\n    margin-right: 10px;\n}\n.cart-btn {\n    font-size: 20px;\n    color: #000;\n}\n.user-profile span {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    color: #000;\n}\n.account-balance {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--darkblue);\n}\n.account-balance span.fw-bold {\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 32px;\n}\n\n.header-logo img {\n    min-width: 100px;\n}\n\n.user-pname {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    color: #000;\n}\n\n.logout_button,\n.logout_button:hover{\n    border: 0px;\n    width: 100%;\n    text-align: left;\n    background-color: transparent !important;\n    color: #515457 !important;\n    padding: 0px;\n    padding-left: 16px;\n    font-weight: 500;\n}\n\n.inlogin_navbar .header-ul .nav-item {\nwhite-space: nowrap;\n}\n\n.balanace_seriel .dropdown-toggle::after{\ndisplay: none;\n}\n.balanace_seriel .dropdown-toggle{\n    padding-bottom: 0px;\n    padding-top: 0px;\n}\n\n/*==== Min Width media query ====*/\n\n\n@media only screen and (max-width: 1555px){\n    @media only screen and (min-width: 1400px){\n        .header-content.inlogin_navbar{\n            flex-wrap: nowrap ;\n        }\n        .header-content.inlogin_navbar .header-right,\n        .header-content.inlogin_navbar .header-left\n        {\n            width:auto;\n        }\n\n       \n         \n    }\n    .header-content.inlogin_navbar .header-left ul.login_show_mobile{\n        gap: 9px;\n    }\n        .header-content.inlogin_navbar .header-left{\n            align-items: center;\n        }\n        .header-content.inlogin_navbar .header-center .search-bar{\n                    max-width: 100%;\n        }\n        .header-content.inlogin_navbar .header-center .search-bar .responsive_width {\n            max-width: 100% !important;\n        }\n\n        @media only screen and (max-width: 1399.98px){\n            .header-content.inlogin_navbar{\n                flex-wrap: wrap;\n            }\n        }\n .header-ul li{\n    white-space: nowrap;\n }\n    .header-content.nologin_navbar{\n        flex-wrap: nowrap;\n    }\n    .header-left{\n        width: 100%;\n        justify-content: space-between;\n    }\n    .header-right{\n        width:100%;\n        display: flex;\n        justify-content: end;\n    }\n    .header-right.nologin_navbar{\n        margin-top: 0px;\n        width: auto;\n    }\n    .product_listing {\n        margin-top: 323px;\n    }\n}\n\n@media only screen and (min-width: 768px){\n  \n}\n\n@media only screen and (min-width: 992px){\n    .responsive_width{\n        /* max-width: 338px !important; */\n        max-width: 100% !important;\n    }\n}\n\n@media only screen and (min-width: 425px) and (max-width:575.98px){\n    /* .header-left, */\n    .header-content{\n        /* display: block !important; */\n    }\n    .header-content.nologin_navbar.reponsive_nologin{\n        display: flex !important;\n    }\n\n\n}\n\n/*==== Min & Max Width media query ====*/\n@media only screen and (min-width: 767px) and (max-width: 1200px){\n}\n\n/*==== Max Width media query ====*/\n\n@media only screen and (max-width: 1200px){\n  \n}\n\n@media only screen and (max-width: 991px){\n.account-balance span {\n    font-size: 16px;\n}\n.header-ul .nav-item {\n    padding-left: 10px;\n}\n.header-ul .nav-item .btn-main {\n    /* border-radius: 10px; */\n    padding: 6px 12px;\n}\n.header-content {\n    padding: 10px 10px;\n}  \n.user-photo {\n    margin-right: 0px;\n}\n}\n\n@media only screen and (max-width: 767px){\n    .account-balance span {\n        font-size: 14px !important;\n    }\n}\n\n@media only screen and (max-width: 1100px){\n    .user-pname{\n        display:none;\n    }\n}\n\n@media only screen and (max-width: 575px){\n    \n    .header-content.nologin_navbar{\n        flex-wrap: wrap;\n    }\n    .header-right.nologin_navbar{\n        margin-top: 15px;\n    }\n    .header-content.nologin_navbar   .header-left {\n        width: 100% !important;\n    }\n    div.header-content.nologin_navbar.reponsive_nologin{\n        flex-wrap: nowrap !important;\n        align-items: center !important;\n    }\n}\n\n@media only screen and (max-width: 425px){\n.header-logo img {\n    min-width: 150px;\n}\n.header-logo {\n    max-width: 32px;\n    overflow: hidden;\n    display: block;\n}\n\n.mobile_View_logo img{\n    max-width: 80px !important;\n    max-height: 36px !important;\n}\n\n}\n\n.balanace_seriel{\n    display: none;\n}\n\n\n.dropdown_header,.dropdown_header:hover,.dropdown_header.btn:first-child:active {\nbackground-color: #ffffff00 !important;\nborder: 0px;\ncolor: #000 !important; \n}\n.dropdown_header svg{\n    color: blue;\n}\n\n@media screen and (max-Width:776px) {\n    .balanace_seriel{\n        display: block;\n    }\n    .bonus_cash{\n     display: none;\n    }\n}\n\n/* @media screen and (min-Width:657px) and (max-width:658px) {\n    .bonus_cash{\n        display: block;\n    }\n} */\n\n@media only screen and (min-width: 993px) {\n    .header_center {\n        position: absolute;\n        left: 205px;\n        max-width: 70%;\n    }\n}\n@media only screen and (max-width: 992px) {\n    .header_center {\n        position: absolute;\n        left: 205px;\n        max-width: 30%;\n    }\n}\n@media only screen and (min-width: 776px) and (max-width: 949px) {\n    .header_center {\n        position: absolute;\n        left: 205px;\n        max-width: 30%;\n    }\n}\n@media only screen and (min-width: 676px) and (max-width: 775px) {\n    .header_center {\n        position: absolute;\n        left: 205px;\n        max-width: 45%;\n    }\n}\n@media only screen and (min-width: 605px) and (max-width: 675px) {\n    .header_center {\n        position: absolute;\n        left: 185px;\n        max-width: 40%;\n    }\n}\n@media only screen and (min-width: 577px) and (max-width: 604px) {\n    .header_center {\n        position: absolute;\n        left: 205px;\n        max-width: 35%;\n    }\n}\n/* @media only screen and (min-width: 670px) and (max-width: 699px) {\n    .header_center {\n        position: absolute;\n        left: 205px;\n        max-width: 25%;\n    }\n} */\n@media only screen and (min-width: 516px) and (max-width: 576px) {\n    .header_center {\n        position: absolute;\n        left: 195px;\n        max-width: 37%;\n    }\n}\n@media only screen and (min-width: 480px) and (max-width: 515px) {\n    .header_center {\n        position: absolute;\n        left: 195px;\n        max-width: 35%;\n    }\n}\n@media only screen and (min-width: 425px) and (max-width: 479px) {\n    .header_center {\n        position: absolute;\n        left: 190px;\n        max-width: 27%;\n    }\n}\n@media only screen and (min-width: 340px) and (max-width: 424px) {\n    .header_center {\n        position: absolute;\n        left: 65px;\n        max-width: 40%;\n    }\n}\n@media only screen and (min-width: 300px) and (max-width: 339px) {\n    .header_center {\n        position: absolute;\n        left: 50px;\n        max-width: 40%;\n    }\n}\n\n\n@media only screen and (max-width: 991px) {\n    .search-bar {\n        margin-right: 0!important;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
